import { useEffect, useState, type ReactElement } from 'react';
import { useOutletContext, useParams } from 'react-router';
import { listerExecutionsDuProjet, type LigneExecution } from '../executions.js';
import { EchecApi } from '../api.js';

interface Espace { readonly code: string; readonly nom: string; readonly role: string }

/**
 * LES EXECUTIONS D UN PROJET [29-F].
 *
 * VUE SITUEE, servie par une route DEDIEE. Ni agregation de N appels par
 * automatisation, ni filtrage d une vue transversale du locataire : le
 * perimetre est prouve par le moteur, et la pagination reste celle d un
 * seul ensemble.
 *
 * LA PREMIERE PAGE SEULEMENT. `curseur_suivant` existe dans la facade et
 * n est pas consomme ici : afficher un bouton qui ne mene nulle part serait
 * une action fictive [28-AB]. Le jour ou un projet en aura besoin, le geste
 * naitra avec sa raison.
 *
 * L ETAT EST AFFICHE TEL QUEL. Le traduire en libelle francais demanderait
 * une table fermee comme celle des natures d environnement ; la liste des
 * etats du moteur n a pas ete mesuree, et inventer une correspondance
 * partielle afficherait un etat inconnu comme vide.
 */
export function Executions(): ReactElement {
  const espace = useOutletContext<Espace>();
  const { projet } = useParams<{ projet: string }>();
  const code = projet ?? '';
  const [liste, poserListe] = useState<readonly LigneExecution[] | undefined>(undefined);
  const [echec, poserEchec] = useState<string | undefined>(undefined);
  useEffect(() => {
    let vivant = true;
    void (async () => {
      try {
        const r = await listerExecutionsDuProjet(espace.code, code);
        if (vivant) poserListe(r.executions);
      } catch (e) {
        if (vivant) poserEchec(e instanceof EchecApi
          ? e.detail.code : 'Chargement impossible.');
      }
    })();
    return () => { vivant = false; };
  }, [espace.code, code]);
  if (echec !== undefined) {
    return <p className="message message--refus">{echec}</p>;
  }
  if (liste === undefined) {
    return <p className="discret">Chargement...</p>;
  }
  if (liste.length === 0) {
    return <p className="discret">Aucune execution pour ce projet.</p>;
  }
  return (
    <div className="grille">
      {liste.map((x) => (
        <article className="carte" key={x.id}>
          <h2 className="carte__titre">{x.automatisation.nom}</h2>
          <p className="carte__detail">{x.etat}</p>
          <p className="discret">{x.demarre_le}</p>
        </article>
      ))}
    </div>
  );
}
